import {
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Typography,
} from '@mui/material'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConf from '$config/frontend'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { InviteLink } from '@weblite/ts-action/hall'
import { UserListItemWithStatus } from '$common/user-list-item'
import { SettingsSection } from '$common/settings-section'
import { BottomDrawer } from '$common/bottom-drawer'
import { LinkInput } from '$common/input'
import { openJoinedViaInviteLink, openUserProfile } from '$logic/router'
import { CopyIcon } from '$common/icons/copy'
import { nothing } from '$func/utils'
import { t } from '$i18n'
import { copyToClipboard } from '$func/clipboard'
import { showLinkSavedInMemorySnackbar } from '$comp/snackbars'

interface Props {
  roomId: string
  inviteLink: InviteLink
  isOpen: boolean
}

export function InviteLinkDetailsModal({ roomId, inviteLink, isOpen }: Props) {
  const { link, isRevoked, creatorId } = inviteLink

  const onCreatorClick = async () => {
    await closeCurrentModal()
    openUserProfile(creatorId)
  }

  const onJoinedViaLink = async () => {
    await closeCurrentModal()
    openJoinedViaInviteLink(roomId, inviteLink)
  }

  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Box sx={{ backgroundColor: 'veryLightGray' }}>
        <SettingsSection
          sx={{ paddingBottom: '5px' }}
          headerText={
            isRevoked
              ? t('inviteLinks.common.expiredLink')
              : t('inviteLinks.common.inviteLink')
          }
        >
          <ListItem>
            <LinkInput
              disabled
              direction="ltr"
              identifier={`+${link}`}
              onChange={nothing}
              handleChange={nothing}
              endIcon={!isRevoked ? <CopyIcon /> : null}
              onEndIconClick={() => {
                copyToClipboard(`${hostConf.FRONT_HOST}/+${link}`)
                showLinkSavedInMemorySnackbar()
              }}
            />
          </ListItem>
        </SettingsSection>

        <SettingsSection headerText={t('inviteLinks.modal.linkIsCreatedBy')}>
          <UserListItemWithStatus
            userId={creatorId}
            role={t('common.owner')}
            onClick={onCreatorClick}
          />
        </SettingsSection>

        <SettingsSection>
          <ListItemButton onClick={onJoinedViaLink}>
            <ListItemText
              primary={
                <Typography variant="subtitle3" color="secondary">
                  {t('inviteLinks.modal.joinedUser')}
                </Typography>
              }
            />
          </ListItemButton>
        </SettingsSection>
      </Box>
    </BottomDrawer>
  )
}
